// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[class^=ant],
[class^=perxis-auto] {
  -webkit-tap-highlight-color: transparent;
}

@media (min-width: 1600px) {
  :root {
    --perxis-auto-gap-vertical-pink-inner: var(--perxis-auto-gap-vertical-pink-xxl, 102px);
    --perxis-auto-gap-vertical-red-inner: var(--perxis-auto-gap-vertical-red-xxl, 76px);
    --perxis-auto-gap-vertical-orange-inner: var(--perxis-auto-gap-vertical-orange-xxl, 54px);
    --perxis-auto-gap-vertical-yellow-inner: var(--perxis-auto-gap-vertical-yellow-xxl, 36px);
    --perxis-auto-gap-vertical-green-inner: var(--perxis-auto-gap-vertical-green-xxl, 24px);
    --perxis-auto-gap-vertical-sky-inner: var(--perxis-auto-gap-vertical-sky-xxl, 16px);
    --perxis-auto-gap-vertical-blue-inner: var(--perxis-auto-gap-vertical-blue-xxl, 12px);
    --perxis-auto-gap-vertical-purple-inner: var(--perxis-auto-gap-vertical-purple-xxl, 8px);
    --perxis-auto-gap-horizontal-inner: var(--perxis-auto-gap-horizontal-xxl, 42px);
  }
}
@media (min-width: 1200px) and (max-width: 1599px) {
  :root {
    --perxis-auto-gap-vertical-pink-inner: var(--perxis-auto-gap-vertical-pink-xl, 102px);
    --perxis-auto-gap-vertical-red-inner: var(--perxis-auto-gap-vertical-red-xl, 76px);
    --perxis-auto-gap-vertical-orange-inner: var(--perxis-auto-gap-vertical-orange-xl, 54px);
    --perxis-auto-gap-vertical-yellow-inner: var(--perxis-auto-gap-vertical-yellow-xl, 36px);
    --perxis-auto-gap-vertical-green-inner: var(--perxis-auto-gap-vertical-green-xl, 24px);
    --perxis-auto-gap-vertical-sky-inner: var(--perxis-auto-gap-vertical-sky-xl, 16px);
    --perxis-auto-gap-vertical-blue-inner: var(--perxis-auto-gap-vertical-blue-xl, 12px);
    --perxis-auto-gap-vertical-purple-inner: var(--perxis-auto-gap-vertical-purple-xl, 8px);
    --perxis-auto-gap-horizontal-inner: var(--perxis-auto-gap-horizontal-xl, 36px);
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  :root {
    --perxis-auto-gap-vertical-pink-inner: var(--perxis-auto-gap-vertical-pink-lg, 84px);
    --perxis-auto-gap-vertical-red-inner: var(--perxis-auto-gap-vertical-red-lg, 60px);
    --perxis-auto-gap-vertical-orange-inner: var(--perxis-auto-gap-vertical-orange-lg, 42px);
    --perxis-auto-gap-vertical-yellow-inner: var(--perxis-auto-gap-vertical-yellow-lg, 28px);
    --perxis-auto-gap-vertical-green-inner: var(--perxis-auto-gap-vertical-green-lg, 24px);
    --perxis-auto-gap-vertical-sky-inner: var(--perxis-auto-gap-vertical-sky-lg, 16px);
    --perxis-auto-gap-vertical-blue-inner: var(--perxis-auto-gap-vertical-blue-lg, 12px);
    --perxis-auto-gap-vertical-purple-inner: var(--perxis-auto-gap-vertical-purple-lg, 8px);
    --perxis-auto-gap-horizontal-inner: var(--perxis-auto-gap-horizontal-lg, 32px);
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  :root {
    --perxis-auto-gap-vertical-pink-inner: var(--perxis-auto-gap-vertical-pink-md, 68px);
    --perxis-auto-gap-vertical-red-inner: var(--perxis-auto-gap-vertical-red-md, 48px);
    --perxis-auto-gap-vertical-orange-inner: var(--perxis-auto-gap-vertical-orange-md, 36px);
    --perxis-auto-gap-vertical-yellow-inner: var(--perxis-auto-gap-vertical-yellow-md, 28px);
    --perxis-auto-gap-vertical-green-inner: var(--perxis-auto-gap-vertical-green-md, 24px);
    --perxis-auto-gap-vertical-sky-inner: var(--perxis-auto-gap-vertical-sky-md, 16px);
    --perxis-auto-gap-vertical-blue-inner: var(--perxis-auto-gap-vertical-blue-md, 12px);
    --perxis-auto-gap-vertical-purple-inner: var(--perxis-auto-gap-vertical-purple-md, 8px);
    --perxis-auto-gap-horizontal-inner: var(--perxis-auto-gap-horizontal-md, 28px);
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  :root {
    --perxis-auto-gap-vertical-pink-inner: var(--perxis-auto-gap-vertical-pink-sm, 48px);
    --perxis-auto-gap-vertical-red-inner: var(--perxis-auto-gap-vertical-red-sm, 36px);
    --perxis-auto-gap-vertical-orange-inner: var(--perxis-auto-gap-vertical-orange-sm, 32px);
    --perxis-auto-gap-vertical-yellow-inner: var(--perxis-auto-gap-vertical-yellow-sm, 28px);
    --perxis-auto-gap-vertical-green-inner: var(--perxis-auto-gap-vertical-green-sm, 24px);
    --perxis-auto-gap-vertical-sky-inner: var(--perxis-auto-gap-vertical-sky-sm, 16px);
    --perxis-auto-gap-vertical-blue-inner: var(--perxis-auto-gap-vertical-blue-sm, 12px);
    --perxis-auto-gap-vertical-purple-inner: var(--perxis-auto-gap-vertical-purple-sm, 8px);
    --perxis-auto-gap-horizontal-inner: var(--perxis-auto-gap-horizontal-xs, 24px);
  }
}
@media (min-width: 480px) and (max-width: 575px) {
  :root {
    --perxis-auto-gap-vertical-pink-inner: var(--perxis-auto-gap-vertical-pink-xs, 36px);
    --perxis-auto-gap-vertical-red-inner: var(--perxis-auto-gap-vertical-red-xs, 32px);
    --perxis-auto-gap-vertical-orange-inner: var(--perxis-auto-gap-vertical-orange-xs, 28px);
    --perxis-auto-gap-vertical-yellow-inner: var(--perxis-auto-gap-vertical-yellow-xs, 24px);
    --perxis-auto-gap-vertical-green-inner: var(--perxis-auto-gap-vertical-green-xs, 20px);
    --perxis-auto-gap-vertical-sky-inner: var(--perxis-auto-gap-vertical-sky-xs, 16px);
    --perxis-auto-gap-vertical-blue-inner: var(--perxis-auto-gap-vertical-blue-xs, 12px);
    --perxis-auto-gap-vertical-purple-inner: var(--perxis-auto-gap-vertical-purple-xs, 8px);
    --perxis-auto-gap-horizontal-inner: var(--perxis-auto-gap-horizontal-xs, 18px);
  }
}
@media (min-width: 0px) and (max-width: 479px) {
  :root {
    --perxis-auto-gap-vertical-pink-inner: var(--perxis-auto-gap-vertical-pink-xxs, 36px);
    --perxis-auto-gap-vertical-red-inner: var(--perxis-auto-gap-vertical-red-xxs, 32px);
    --perxis-auto-gap-vertical-orange-inner: var(--perxis-auto-gap-vertical-orange-xxs, 28px);
    --perxis-auto-gap-vertical-yellow-inner: var(--perxis-auto-gap-vertical-yellow-xxs, 24px);
    --perxis-auto-gap-vertical-green-inner: var(--perxis-auto-gap-vertical-green-xxs, 20px);
    --perxis-auto-gap-vertical-sky-inner: var(--perxis-auto-gap-vertical-sky-xxs, 16px);
    --perxis-auto-gap-vertical-blue-inner: var(--perxis-auto-gap-vertical-blue-xxs, 12px);
    --perxis-auto-gap-vertical-purple-inner: var(--perxis-auto-gap-vertical-purple-xxs, 8px);
    --perxis-auto-gap-horizontal-inner: var(--perxis-auto-gap-horizontal-xxs, 18px);
  }
}

:root {
  --perxis-auto-root-typography-font-family-inner: var(--perxis-auto-root-typography-font-family, "Proxima Nova");
  --perxis-auto-root-typography-font-variant-numeric-inner: var(
    --perxis-auto-root-typography-font-variant-numeric,
    normal
  );
  --perxis-auto-root-typography-h1-font-family-inner: var(
    --perxis-auto-root-typography-h1-font-family,
    var(--perxis-auto-root-typography-font-family-inner)
  );
  --perxis-auto-root-typography-h1-font-variant-numeric-inner: var(
    --perxis-auto-root-typography-h1-font-variant-numeric,
    var(--perxis-auto-root-typography-font-variant-numeric-inner)
  );
  --perxis-auto-root-typography-h1-font-weight-inner: var(--perxis-auto-root-typography-h1-font-weight, 700);
  --perxis-auto-root-typography-h1-letter-spacing-inner: var(--perxis-auto-root-typography-h1-letter-spacing, 0);
  --perxis-auto-root-typography-h1-text-transform-inner: var(--perxis-auto-root-typography-h1-text-transform, none);
  --perxis-auto-root-typography-h1-font-size-xxl-inner: var(--perxis-auto-root-typography-h1-font-size-xxl, 36px);
  --perxis-auto-root-typography-h1-line-height-xxl-inner: var(--perxis-auto-root-typography-h1-line-height-xxl, 1);
  --perxis-auto-root-typography-h1-font-size-xl-inner: var(
    --perxis-auto-root-typography-h1-font-size-xl,
    var(--perxis-auto-root-typography-h1-font-size-xxl-inner)
  );
  --perxis-auto-root-typography-h1-line-height-xl-inner: var(
    --perxis-auto-root-typography-h1-line-height-xl,
    var(--perxis-auto-root-typography-h1-line-height-xxl-inner)
  );
  --perxis-auto-root-typography-h1-font-size-lg-inner: var(
    --perxis-auto-root-typography-h1-font-size-lg,
    var(--perxis-auto-root-typography-h1-font-size-xl-inner)
  );
  --perxis-auto-root-typography-h1-line-height-lg-inner: var(
    --perxis-auto-root-typography-h1-line-height-lg,
    var(--perxis-auto-root-typography-h1-line-height-xl-inner)
  );
  --perxis-auto-root-typography-h1-font-size-md-inner: var(
    --perxis-auto-root-typography-h1-font-size-md,
    var(--perxis-auto-root-typography-h1-font-size-lg-inner)
  );
  --perxis-auto-root-typography-h1-line-height-md-inner: var(
    --perxis-auto-root-typography-h1-line-height-md,
    var(--perxis-auto-root-typography-h1-line-height-lg-inner)
  );
  --perxis-auto-root-typography-h1-font-size-sm-inner: var(
    --perxis-auto-root-typography-h1-font-size-sm,
    var(--perxis-auto-root-typography-h1-font-size-md-inner)
  );
  --perxis-auto-root-typography-h1-line-height-sm-inner: var(
    --perxis-auto-root-typography-h1-line-height-sm,
    var(--perxis-auto-root-typography-h1-line-height-md-inner)
  );
  --perxis-auto-root-typography-h1-font-size-xs-inner: var(
    --perxis-auto-root-typography-h1-font-size-xs,
    var(--perxis-auto-root-typography-h1-font-size-sm-inner)
  );
  --perxis-auto-root-typography-h1-line-height-xs-inner: var(
    --perxis-auto-root-typography-h1-line-height-xs,
    var(--perxis-auto-root-typography-h1-line-height-sm-inner)
  );
  --perxis-auto-root-typography-h1-font-size-xxs-inner: var(
    --perxis-auto-root-typography-h1-font-size-xxs,
    var(--perxis-auto-root-typography-h1-font-size-xs-inner)
  );
  --perxis-auto-root-typography-h1-line-height-xxs-inner: var(
    --perxis-auto-root-typography-h1-line-height-xxs,
    var(--perxis-auto-root-typography-h1-line-height-xs-inner)
  );
  --perxis-auto-root-typography-h2-font-family-inner: var(
    --perxis-auto-root-typography-h2-font-family,
    var(--perxis-auto-root-typography-font-family-inner)
  );
  --perxis-auto-root-typography-h2-font-variant-numeric-inner: var(
    --perxis-auto-root-typography-h2-font-variant-numeric,
    var(--perxis-auto-root-typography-font-variant-numeric-inner)
  );
  --perxis-auto-root-typography-h2-font-weight-inner: var(--perxis-auto-root-typography-h2-font-weight, 700);
  --perxis-auto-root-typography-h2-letter-spacing-inner: var(--perxis-auto-root-typography-h2-letter-spacing, 0);
  --perxis-auto-root-typography-h2-text-transform-inner: var(--perxis-auto-root-typography-h2-text-transform, none);
  --perxis-auto-root-typography-h2-font-size-xxl-inner: var(--perxis-auto-root-typography-h2-font-size-xxl, 28px);
  --perxis-auto-root-typography-h2-line-height-xxl-inner: var(--perxis-auto-root-typography-h2-line-height-xxl, 1);
  --perxis-auto-root-typography-h2-font-size-xl-inner: var(
    --perxis-auto-root-typography-h2-font-size-xl,
    var(--perxis-auto-root-typography-h2-font-size-xxl-inner)
  );
  --perxis-auto-root-typography-h2-line-height-xl-inner: var(
    --perxis-auto-root-typography-h2-line-height-xl,
    var(--perxis-auto-root-typography-h2-line-height-xxl-inner)
  );
  --perxis-auto-root-typography-h2-font-size-lg-inner: var(
    --perxis-auto-root-typography-h2-font-size-lg,
    var(--perxis-auto-root-typography-h2-font-size-xl-inner)
  );
  --perxis-auto-root-typography-h2-line-height-lg-inner: var(
    --perxis-auto-root-typography-h2-line-height-lg,
    var(--perxis-auto-root-typography-h2-line-height-xl-inner)
  );
  --perxis-auto-root-typography-h2-font-size-md-inner: var(
    --perxis-auto-root-typography-h2-font-size-md,
    var(--perxis-auto-root-typography-h2-font-size-lg-inner)
  );
  --perxis-auto-root-typography-h2-line-height-md-inner: var(
    --perxis-auto-root-typography-h2-line-height-md,
    var(--perxis-auto-root-typography-h2-line-height-lg-inner)
  );
  --perxis-auto-root-typography-h2-font-size-sm-inner: var(
    --perxis-auto-root-typography-h2-font-size-sm,
    var(--perxis-auto-root-typography-h2-font-size-md-inner)
  );
  --perxis-auto-root-typography-h2-line-height-sm-inner: var(
    --perxis-auto-root-typography-h2-line-height-sm,
    var(--perxis-auto-root-typography-h2-line-height-md-inner)
  );
  --perxis-auto-root-typography-h2-font-size-xs-inner: var(
    --perxis-auto-root-typography-h2-font-size-xs,
    var(--perxis-auto-root-typography-h2-font-size-sm-inner)
  );
  --perxis-auto-root-typography-h2-line-height-xs-inner: var(
    --perxis-auto-root-typography-h2-line-height-xs,
    var(--perxis-auto-root-typography-h2-line-height-sm-inner)
  );
  --perxis-auto-root-typography-h2-font-size-xxs-inner: var(
    --perxis-auto-root-typography-h2-font-size-xxs,
    var(--perxis-auto-root-typography-h2-font-size-xs-inner)
  );
  --perxis-auto-root-typography-h2-line-height-xxs-inner: var(
    --perxis-auto-root-typography-h2-line-height-xxs,
    var(--perxis-auto-root-typography-h2-line-height-xs-inner)
  );
  --perxis-auto-root-typography-h3-font-family-inner: var(
    --perxis-auto-root-typography-h3-font-family,
    var(--perxis-auto-root-typography-font-family-inner)
  );
  --perxis-auto-root-typography-h3-font-variant-numeric-inner: var(
    --perxis-auto-root-typography-h3-font-variant-numeric,
    var(--perxis-auto-root-typography-font-variant-numeric-inner)
  );
  --perxis-auto-root-typography-h3-font-weight-inner: var(--perxis-auto-root-typography-h3-font-weight, 700);
  --perxis-auto-root-typography-h3-letter-spacing-inner: var(--perxis-auto-root-typography-h3-letter-spacing, 0);
  --perxis-auto-root-typography-h3-text-transform-inner: var(--perxis-auto-root-typography-h3-text-transform, none);
  --perxis-auto-root-typography-h3-font-size-xxl-inner: var(--perxis-auto-root-typography-h3-font-size-xxl, 24px);
  --perxis-auto-root-typography-h3-line-height-xxl-inner: var(--perxis-auto-root-typography-h3-line-height-xxl, 1);
  --perxis-auto-root-typography-h3-font-size-xl-inner: var(
    --perxis-auto-root-typography-h3-font-size-xl,
    var(--perxis-auto-root-typography-h3-font-size-xxl-inner)
  );
  --perxis-auto-root-typography-h3-line-height-xl-inner: var(
    --perxis-auto-root-typography-h3-line-height-xl,
    var(--perxis-auto-root-typography-h3-line-height-xxl-inner)
  );
  --perxis-auto-root-typography-h3-font-size-lg-inner: var(
    --perxis-auto-root-typography-h3-font-size-lg,
    var(--perxis-auto-root-typography-h3-font-size-xl-inner)
  );
  --perxis-auto-root-typography-h3-line-height-lg-inner: var(
    --perxis-auto-root-typography-h3-line-height-lg,
    var(--perxis-auto-root-typography-h3-line-height-xl-inner)
  );
  --perxis-auto-root-typography-h3-font-size-md-inner: var(
    --perxis-auto-root-typography-h3-font-size-md,
    var(--perxis-auto-root-typography-h3-font-size-lg-inner)
  );
  --perxis-auto-root-typography-h3-line-height-md-inner: var(
    --perxis-auto-root-typography-h3-line-height-md,
    var(--perxis-auto-root-typography-h3-line-height-lg-inner)
  );
  --perxis-auto-root-typography-h3-font-size-sm-inner: var(
    --perxis-auto-root-typography-h3-font-size-sm,
    var(--perxis-auto-root-typography-h3-font-size-md-inner)
  );
  --perxis-auto-root-typography-h3-line-height-sm-inner: var(
    --perxis-auto-root-typography-h3-line-height-sm,
    var(--perxis-auto-root-typography-h3-line-height-md-inner)
  );
  --perxis-auto-root-typography-h3-font-size-xs-inner: var(
    --perxis-auto-root-typography-h3-font-size-xs,
    var(--perxis-auto-root-typography-h3-font-size-sm-inner)
  );
  --perxis-auto-root-typography-h3-line-height-xs-inner: var(
    --perxis-auto-root-typography-h3-line-height-xs,
    var(--perxis-auto-root-typography-h3-line-height-sm-inner)
  );
  --perxis-auto-root-typography-h3-font-size-xxs-inner: var(
    --perxis-auto-root-typography-h3-font-size-xxs,
    var(--perxis-auto-root-typography-h3-font-size-xs-inner)
  );
  --perxis-auto-root-typography-h3-line-height-xxs-inner: var(
    --perxis-auto-root-typography-h3-line-height-xxs,
    var(--perxis-auto-root-typography-h3-line-height-xs-inner)
  );
  --perxis-auto-root-typography-h4-font-family-inner: var(
    --perxis-auto-root-typography-h4-font-family,
    var(--perxis-auto-root-typography-font-family-inner)
  );
  --perxis-auto-root-typography-h4-font-variant-numeric-inner: var(
    --perxis-auto-root-typography-h4-font-variant-numeric,
    var(--perxis-auto-root-typography-font-variant-numeric-inner)
  );
  --perxis-auto-root-typography-h4-font-weight-inner: var(--perxis-auto-root-typography-h4-font-weight, 700);
  --perxis-auto-root-typography-h4-letter-spacing-inner: var(--perxis-auto-root-typography-h4-letter-spacing, 0);
  --perxis-auto-root-typography-h4-text-transform-inner: var(--perxis-auto-root-typography-h4-text-transform, none);
  --perxis-auto-root-typography-h4-font-size-xxl-inner: var(--perxis-auto-root-typography-h4-font-size-xxl, 20px);
  --perxis-auto-root-typography-h4-line-height-xxl-inner: var(--perxis-auto-root-typography-h4-line-height-xxl, 1);
  --perxis-auto-root-typography-h4-font-size-xl-inner: var(
    --perxis-auto-root-typography-h4-font-size-xl,
    var(--perxis-auto-root-typography-h4-font-size-xxl-inner)
  );
  --perxis-auto-root-typography-h4-line-height-xl-inner: var(
    --perxis-auto-root-typography-h4-line-height-xl,
    var(--perxis-auto-root-typography-h4-line-height-xxl-inner)
  );
  --perxis-auto-root-typography-h4-font-size-lg-inner: var(
    --perxis-auto-root-typography-h4-font-size-lg,
    var(--perxis-auto-root-typography-h4-font-size-xl-inner)
  );
  --perxis-auto-root-typography-h4-line-height-lg-inner: var(
    --perxis-auto-root-typography-h4-line-height-lg,
    var(--perxis-auto-root-typography-h4-line-height-xl-inner)
  );
  --perxis-auto-root-typography-h4-font-size-md-inner: var(
    --perxis-auto-root-typography-h4-font-size-md,
    var(--perxis-auto-root-typography-h4-font-size-lg-inner)
  );
  --perxis-auto-root-typography-h4-line-height-md-inner: var(
    --perxis-auto-root-typography-h4-line-height-md,
    var(--perxis-auto-root-typography-h4-line-height-lg-inner)
  );
  --perxis-auto-root-typography-h4-font-size-sm-inner: var(
    --perxis-auto-root-typography-h4-font-size-sm,
    var(--perxis-auto-root-typography-h4-font-size-md-inner)
  );
  --perxis-auto-root-typography-h4-line-height-sm-inner: var(
    --perxis-auto-root-typography-h4-line-height-sm,
    var(--perxis-auto-root-typography-h4-line-height-md-inner)
  );
  --perxis-auto-root-typography-h4-font-size-xs-inner: var(
    --perxis-auto-root-typography-h4-font-size-xs,
    var(--perxis-auto-root-typography-h4-font-size-sm-inner)
  );
  --perxis-auto-root-typography-h4-line-height-xs-inner: var(
    --perxis-auto-root-typography-h4-line-height-xs,
    var(--perxis-auto-root-typography-h4-line-height-sm-inner)
  );
  --perxis-auto-root-typography-h4-font-size-xxs-inner: var(
    --perxis-auto-root-typography-h4-font-size-xxs,
    var(--perxis-auto-root-typography-h4-font-size-xs-inner)
  );
  --perxis-auto-root-typography-h4-line-height-xxs-inner: var(
    --perxis-auto-root-typography-h4-line-height-xxs,
    var(--perxis-auto-root-typography-h4-line-height-xs-inner)
  );
  --perxis-auto-root-typography-h5-font-family-inner: var(
    --perxis-auto-root-typography-h5-font-family,
    var(--perxis-auto-root-typography-font-family-inner)
  );
  --perxis-auto-root-typography-h5-font-variant-numeric-inner: var(
    --perxis-auto-root-typography-h5-font-variant-numeric,
    var(--perxis-auto-root-typography-font-variant-numeric-inner)
  );
  --perxis-auto-root-typography-h5-font-weight-inner: var(--perxis-auto-root-typography-h5-font-weight, 700);
  --perxis-auto-root-typography-h5-letter-spacing-inner: var(--perxis-auto-root-typography-h5-letter-spacing, 0);
  --perxis-auto-root-typography-h5-text-transform-inner: var(--perxis-auto-root-typography-h5-text-transform, none);
  --perxis-auto-root-typography-h5-font-size-xxl-inner: var(--perxis-auto-root-typography-h5-font-size-xxl, 18px);
  --perxis-auto-root-typography-h5-line-height-xxl-inner: var(--perxis-auto-root-typography-h5-line-height-xxl, 1);
  --perxis-auto-root-typography-h5-font-size-xl-inner: var(
    --perxis-auto-root-typography-h5-font-size-xl,
    var(--perxis-auto-root-typography-h5-font-size-xxl-inner)
  );
  --perxis-auto-root-typography-h5-line-height-xl-inner: var(
    --perxis-auto-root-typography-h5-line-height-xl,
    var(--perxis-auto-root-typography-h5-line-height-xxl-inner)
  );
  --perxis-auto-root-typography-h5-font-size-lg-inner: var(
    --perxis-auto-root-typography-h5-font-size-lg,
    var(--perxis-auto-root-typography-h5-font-size-xl-inner)
  );
  --perxis-auto-root-typography-h5-line-height-lg-inner: var(
    --perxis-auto-root-typography-h5-line-height-lg,
    var(--perxis-auto-root-typography-h5-line-height-xl-inner)
  );
  --perxis-auto-root-typography-h5-font-size-md-inner: var(
    --perxis-auto-root-typography-h5-font-size-md,
    var(--perxis-auto-root-typography-h5-font-size-lg-inner)
  );
  --perxis-auto-root-typography-h5-line-height-md-inner: var(
    --perxis-auto-root-typography-h5-line-height-md,
    var(--perxis-auto-root-typography-h5-line-height-lg-inner)
  );
  --perxis-auto-root-typography-h5-font-size-sm-inner: var(
    --perxis-auto-root-typography-h5-font-size-sm,
    var(--perxis-auto-root-typography-h5-font-size-md-inner)
  );
  --perxis-auto-root-typography-h5-line-height-sm-inner: var(
    --perxis-auto-root-typography-h5-line-height-sm,
    var(--perxis-auto-root-typography-h5-line-height-md-inner)
  );
  --perxis-auto-root-typography-h5-font-size-xs-inner: var(
    --perxis-auto-root-typography-h5-font-size-xs,
    var(--perxis-auto-root-typography-h5-font-size-sm-inner)
  );
  --perxis-auto-root-typography-h5-line-height-xs-inner: var(
    --perxis-auto-root-typography-h5-line-height-xs,
    var(--perxis-auto-root-typography-h5-line-height-sm-inner)
  );
  --perxis-auto-root-typography-h5-font-size-xxs-inner: var(
    --perxis-auto-root-typography-h5-font-size-xxs,
    var(--perxis-auto-root-typography-h5-font-size-xs-inner)
  );
  --perxis-auto-root-typography-h5-line-height-xxs-inner: var(
    --perxis-auto-root-typography-h5-line-height-xxs,
    var(--perxis-auto-root-typography-h5-line-height-xs-inner)
  );
  --perxis-auto-root-typography-marker-font-family-inner: var(
    --perxis-auto-root-typography-marker-font-family,
    var(--perxis-auto-root-typography-font-family-inner)
  );
  --perxis-auto-root-typography-marker-font-variant-numeric-inner: var(
    --perxis-auto-root-typography-marker-font-variant-numeric,
    var(--perxis-auto-root-typography-font-variant-numeric-inner)
  );
  --perxis-auto-root-typography-marker-font-weight-inner: var(--perxis-auto-root-typography-marker-font-weight, 400);
  --perxis-auto-root-typography-marker-letter-spacing-inner: var(
    --perxis-auto-root-typography-marker-letter-spacing,
    0
  );
  --perxis-auto-root-typography-marker-text-transform-inner: var(
    --perxis-auto-root-typography-marker-text-transform,
    none
  );
  --perxis-auto-root-typography-marker-font-size-xxl-inner: var(
    --perxis-auto-root-typography-marker-font-size-xxl,
    11px
  );
  --perxis-auto-root-typography-marker-line-height-xxl-inner: var(
    --perxis-auto-root-typography-marker-line-height-xxl,
    1.18
  );
  --perxis-auto-root-typography-marker-font-size-xl-inner: var(
    --perxis-auto-root-typography-marker-font-size-xl,
    var(--perxis-auto-root-typography-marker-font-size-xxl-inner)
  );
  --perxis-auto-root-typography-marker-line-height-xl-inner: var(
    --perxis-auto-root-typography-marker-line-height-xl,
    var(--perxis-auto-root-typography-marker-line-height-xxl-inner)
  );
  --perxis-auto-root-typography-marker-font-size-lg-inner: var(
    --perxis-auto-root-typography-marker-font-size-lg,
    var(--perxis-auto-root-typography-marker-font-size-xl-inner)
  );
  --perxis-auto-root-typography-marker-line-height-lg-inner: var(
    --perxis-auto-root-typography-marker-line-height-lg,
    var(--perxis-auto-root-typography-marker-line-height-xl-inner)
  );
  --perxis-auto-root-typography-marker-font-size-md-inner: var(
    --perxis-auto-root-typography-marker-font-size-md,
    var(--perxis-auto-root-typography-marker-font-size-lg-inner)
  );
  --perxis-auto-root-typography-marker-line-height-md-inner: var(
    --perxis-auto-root-typography-marker-line-height-md,
    var(--perxis-auto-root-typography-marker-line-height-lg-inner)
  );
  --perxis-auto-root-typography-marker-font-size-sm-inner: var(
    --perxis-auto-root-typography-marker-font-size-sm,
    var(--perxis-auto-root-typography-marker-font-size-md-inner)
  );
  --perxis-auto-root-typography-marker-line-height-sm-inner: var(
    --perxis-auto-root-typography-marker-line-height-sm,
    var(--perxis-auto-root-typography-marker-line-height-md-inner)
  );
  --perxis-auto-root-typography-marker-font-size-xs-inner: var(
    --perxis-auto-root-typography-marker-font-size-xs,
    var(--perxis-auto-root-typography-marker-font-size-sm-inner)
  );
  --perxis-auto-root-typography-marker-line-height-xs-inner: var(
    --perxis-auto-root-typography-marker-line-height-xs,
    var(--perxis-auto-root-typography-marker-line-height-sm-inner)
  );
  --perxis-auto-root-typography-marker-font-size-xxs-inner: var(
    --perxis-auto-root-typography-marker-font-size-xxs,
    var(--perxis-auto-root-typography-marker-font-size-xs-inner)
  );
  --perxis-auto-root-typography-marker-line-height-xxs-inner: var(
    --perxis-auto-root-typography-marker-line-height-xxs,
    var(--perxis-auto-root-typography-marker-line-height-xs-inner)
  );
  --perxis-auto-root-typography-main-font-family-inner: var(
    --perxis-auto-root-typography-main-font-family,
    var(--perxis-auto-root-typography-font-family-inner)
  );
  --perxis-auto-root-typography-main-font-variant-numeric-inner: var(
    --perxis-auto-root-typography-main-font-variant-numeric,
    var(--perxis-auto-root-typography-font-variant-numeric-inner)
  );
  --perxis-auto-root-typography-main-font-weight-inner: var(--perxis-auto-root-typography-main-font-weight, 400);
  --perxis-auto-root-typography-main-letter-spacing-inner: var(--perxis-auto-root-typography-main-letter-spacing, 0);
  --perxis-auto-root-typography-main-text-transform-inner: var(--perxis-auto-root-typography-main-text-transform, none);
  --perxis-auto-root-typography-main-font-size-xxl-inner: var(--perxis-auto-root-typography-main-font-size-xxl, 16px);
  --perxis-auto-root-typography-main-line-height-xxl-inner: var(
    --perxis-auto-root-typography-main-line-height-xxl,
    1.5
  );
  --perxis-auto-root-typography-main-font-size-xl-inner: var(
    --perxis-auto-root-typography-main-font-size-xl,
    var(--perxis-auto-root-typography-main-font-size-xxl-inner)
  );
  --perxis-auto-root-typography-main-line-height-xl-inner: var(
    --perxis-auto-root-typography-main-line-height-xl,
    var(--perxis-auto-root-typography-main-line-height-xxl-inner)
  );
  --perxis-auto-root-typography-main-font-size-lg-inner: var(
    --perxis-auto-root-typography-main-font-size-lg,
    var(--perxis-auto-root-typography-main-font-size-xl-inner)
  );
  --perxis-auto-root-typography-main-line-height-lg-inner: var(
    --perxis-auto-root-typography-main-line-height-lg,
    var(--perxis-auto-root-typography-main-line-height-xl-inner)
  );
  --perxis-auto-root-typography-main-font-size-md-inner: var(
    --perxis-auto-root-typography-main-font-size-md,
    var(--perxis-auto-root-typography-main-font-size-lg-inner)
  );
  --perxis-auto-root-typography-main-line-height-md-inner: var(
    --perxis-auto-root-typography-main-line-height-md,
    var(--perxis-auto-root-typography-main-line-height-lg-inner)
  );
  --perxis-auto-root-typography-main-font-size-sm-inner: var(
    --perxis-auto-root-typography-main-font-size-sm,
    var(--perxis-auto-root-typography-main-font-size-md-inner)
  );
  --perxis-auto-root-typography-main-line-height-sm-inner: var(
    --perxis-auto-root-typography-main-line-height-sm,
    var(--perxis-auto-root-typography-main-line-height-md-inner)
  );
  --perxis-auto-root-typography-main-font-size-xs-inner: var(
    --perxis-auto-root-typography-main-font-size-xs,
    var(--perxis-auto-root-typography-main-font-size-sm-inner)
  );
  --perxis-auto-root-typography-main-line-height-xs-inner: var(
    --perxis-auto-root-typography-main-line-height-xs,
    var(--perxis-auto-root-typography-main-line-height-sm-inner)
  );
  --perxis-auto-root-typography-main-font-size-xxs-inner: var(
    --perxis-auto-root-typography-main-font-size-xxs,
    var(--perxis-auto-root-typography-main-font-size-xs-inner)
  );
  --perxis-auto-root-typography-main-line-height-xxs-inner: var(
    --perxis-auto-root-typography-main-line-height-xxs,
    var(--perxis-auto-root-typography-main-line-height-xs-inner)
  );
  --perxis-auto-root-typography-small-font-family-inner: var(
    --perxis-auto-root-typography-small-font-family,
    var(--perxis-auto-root-typography-font-family-inner)
  );
  --perxis-auto-root-typography-small-font-variant-numeric-inner: var(
    --perxis-auto-root-typography-small-font-variant-numeric,
    var(--perxis-auto-root-typography-font-variant-numeric-inner)
  );
  --perxis-auto-root-typography-small-font-weight-inner: var(--perxis-auto-root-typography-small-font-weight, 400);
  --perxis-auto-root-typography-small-letter-spacing-inner: var(--perxis-auto-root-typography-small-letter-spacing, 0);
  --perxis-auto-root-typography-small-text-transform-inner: var(
    --perxis-auto-root-typography-small-text-transform,
    none
  );
  --perxis-auto-root-typography-small-font-size-xxl-inner: var(--perxis-auto-root-typography-small-font-size-xxl, 14px);
  --perxis-auto-root-typography-small-line-height-xxl-inner: var(
    --perxis-auto-root-typography-small-line-height-xxl,
    1.2
  );
  --perxis-auto-root-typography-small-font-size-xl-inner: var(
    --perxis-auto-root-typography-small-font-size-xl,
    var(--perxis-auto-root-typography-small-font-size-xxl-inner)
  );
  --perxis-auto-root-typography-small-line-height-xl-inner: var(
    --perxis-auto-root-typography-small-line-height-xl,
    var(--perxis-auto-root-typography-small-line-height-xxl-inner)
  );
  --perxis-auto-root-typography-small-font-size-lg-inner: var(
    --perxis-auto-root-typography-small-font-size-lg,
    var(--perxis-auto-root-typography-small-font-size-xl-inner)
  );
  --perxis-auto-root-typography-small-line-height-lg-inner: var(
    --perxis-auto-root-typography-small-line-height-lg,
    var(--perxis-auto-root-typography-small-line-height-xl-inner)
  );
  --perxis-auto-root-typography-small-font-size-md-inner: var(
    --perxis-auto-root-typography-small-font-size-md,
    var(--perxis-auto-root-typography-small-font-size-lg-inner)
  );
  --perxis-auto-root-typography-small-line-height-md-inner: var(
    --perxis-auto-root-typography-small-line-height-md,
    var(--perxis-auto-root-typography-small-line-height-lg-inner)
  );
  --perxis-auto-root-typography-small-font-size-sm-inner: var(
    --perxis-auto-root-typography-small-font-size-sm,
    var(--perxis-auto-root-typography-small-font-size-md-inner)
  );
  --perxis-auto-root-typography-small-line-height-sm-inner: var(
    --perxis-auto-root-typography-small-line-height-sm,
    var(--perxis-auto-root-typography-small-line-height-md-inner)
  );
  --perxis-auto-root-typography-small-font-size-xs-inner: var(
    --perxis-auto-root-typography-small-font-size-xs,
    var(--perxis-auto-root-typography-small-font-size-sm-inner)
  );
  --perxis-auto-root-typography-small-line-height-xs-inner: var(
    --perxis-auto-root-typography-small-line-height-xs,
    var(--perxis-auto-root-typography-small-line-height-sm-inner)
  );
  --perxis-auto-root-typography-small-font-size-xxs-inner: var(
    --perxis-auto-root-typography-small-font-size-xxs,
    var(--perxis-auto-root-typography-small-font-size-xs-inner)
  );
  --perxis-auto-root-typography-small-line-height-xxs-inner: var(
    --perxis-auto-root-typography-small-line-height-xxs,
    var(--perxis-auto-root-typography-small-line-height-xs-inner)
  );
  --perxis-auto-root-typography-super-small-font-family-inner: var(
    --perxis-auto-root-typography-super-small-font-family,
    var(--perxis-auto-root-typography-font-family-inner)
  );
  --perxis-auto-root-typography-super-small-font-variant-numeric-inner: var(
    --perxis-auto-root-typography-super-small-font-variant-numeric,
    var(--perxis-auto-root-typography-font-variant-numeric-inner)
  );
  --perxis-auto-root-typography-super-small-font-weight-inner: var(
    --perxis-auto-root-typography-super-small-font-weight,
    400
  );
  --perxis-auto-root-typography-super-small-letter-spacing-inner: var(
    --perxis-auto-root-typography-super-small-letter-spacing,
    0
  );
  --perxis-auto-root-typography-super-small-text-transform-inner: var(
    --perxis-auto-root-typography-super-small-text-transform,
    none
  );
  --perxis-auto-root-typography-super-small-font-size-xxl-inner: var(
    --perxis-auto-root-typography-super-small-font-size-xxl,
    12px
  );
  --perxis-auto-root-typography-super-small-line-height-xxl-inner: var(
    --perxis-auto-root-typography-super-small-line-height-xxl,
    1.5
  );
  --perxis-auto-root-typography-super-small-font-size-xl-inner: var(
    --perxis-auto-root-typography-super-small-font-size-xl,
    var(--perxis-auto-root-typography-super-small-font-size-xxl-inner)
  );
  --perxis-auto-root-typography-super-small-line-height-xl-inner: var(
    --perxis-auto-root-typography-super-small-line-height-xl,
    var(--perxis-auto-root-typography-super-small-line-height-xxl-inner)
  );
  --perxis-auto-root-typography-super-small-font-size-lg-inner: var(
    --perxis-auto-root-typography-super-small-font-size-lg,
    var(--perxis-auto-root-typography-super-small-font-size-xl-inner)
  );
  --perxis-auto-root-typography-super-small-line-height-lg-inner: var(
    --perxis-auto-root-typography-super-small-line-height-lg,
    var(--perxis-auto-root-typography-super-small-line-height-xl-inner)
  );
  --perxis-auto-root-typography-super-small-font-size-md-inner: var(
    --perxis-auto-root-typography-super-small-font-size-md,
    var(--perxis-auto-root-typography-super-small-font-size-lg-inner)
  );
  --perxis-auto-root-typography-super-small-line-height-md-inner: var(
    --perxis-auto-root-typography-super-small-line-height-md,
    var(--perxis-auto-root-typography-super-small-line-height-lg-inner)
  );
  --perxis-auto-root-typography-super-small-font-size-sm-inner: var(
    --perxis-auto-root-typography-super-small-font-size-sm,
    var(--perxis-auto-root-typography-super-small-font-size-md-inner)
  );
  --perxis-auto-root-typography-super-small-line-height-sm-inner: var(
    --perxis-auto-root-typography-super-small-line-height-sm,
    var(--perxis-auto-root-typography-super-small-line-height-md-inner)
  );
  --perxis-auto-root-typography-super-small-font-size-xs-inner: var(
    --perxis-auto-root-typography-super-small-font-size-xs,
    var(--perxis-auto-root-typography-super-small-font-size-sm-inner)
  );
  --perxis-auto-root-typography-super-small-line-height-xs-inner: var(
    --perxis-auto-root-typography-super-small-line-height-xs,
    var(--perxis-auto-root-typography-super-small-line-height-sm-inner)
  );
  --perxis-auto-root-typography-super-small-font-size-xxs-inner: var(
    --perxis-auto-root-typography-super-small-font-size-xxs,
    var(--perxis-auto-root-typography-super-small-font-size-xs-inner)
  );
  --perxis-auto-root-typography-super-small-line-height-xxs-inner: var(
    --perxis-auto-root-typography-super-small-line-height-xxs,
    var(--perxis-auto-root-typography-super-small-line-height-xs-inner)
  );
  --perxis-auto-root-typography-color-darkest-inner: var(
    --perxis-auto-root-typography-color-darkest,
    var(--perxis-auto-root-second-color-inner)
  );
  --perxis-auto-root-typography-color-dark-inner: var(
    --perxis-auto-root-typography-color-dark,
    var(--perxis-auto-root-fourth-color-inner)
  );
  --perxis-auto-root-typography-color-dark-light-inner: var(
    --perxis-auto-root-typography-color-dark-light,
    var(--perxis-auto-root-fifth-color-inner)
  );
  --perxis-auto-root-typography-color-light-inner: var(
    --perxis-auto-root-typography-color-light,
    var(--perxis-auto-root-sixth-color-inner)
  );
  --perxis-auto-root-typography-color-lightest-inner: var(
    --perxis-auto-root-typography-color-lightest,
    var(--perxis-auto-root-first-color-inner)
  );
  --perxis-auto-root-typography-color-darkest-colorful-inner: var(
    --perxis-auto-root-typography-color-darkest-colorful,
    var(--perxis-auto-root-second-color-inner)
  );
  --perxis-auto-root-typography-color-dark-colorful-inner: var(
    --perxis-auto-root-typography-color-dark-colorful,
    var(--perxis-auto-root-eleven-color-inner)
  );
  --perxis-auto-root-typography-color-dark-light-colorful-inner: var(
    --perxis-auto-root-typography-color-dark-light-colorful,
    var(--perxis-auto-root-eighth-color-inner)
  );
  --perxis-auto-root-typography-color-light-colorful-inner: var(
    --perxis-auto-root-typography-color-light-colorful,
    var(--perxis-auto-root-third-color-inner)
  );
  --perxis-auto-root-typography-color-lightest-colorful-inner: var(
    --perxis-auto-root-typography-color-lightest-colorful,
    var(--perxis-auto-root-first-color-inner)
  );
}

:root {
  --perxis-auto-root-first-color-inner: var(--perxis-auto-root-first-color, #FFFFFF);
  --perxis-auto-root-second-color-inner: var(--perxis-auto-root-second-color, #262626);
  --perxis-auto-root-third-color-inner: var(--perxis-auto-root-third-color, #DE0C74);
  --perxis-auto-root-fourth-color-inner: var(--perxis-auto-root-fourth-color, #505050);
  --perxis-auto-root-fifth-color-inner: var(--perxis-auto-root-fifth-color, #7A7A7A);
  --perxis-auto-root-sixth-color-inner: var(--perxis-auto-root-sixth-color, #C2C2C2);
  --perxis-auto-root-seventh-color-inner: var(--perxis-auto-root-seventh-color, #F2F0F0);
  --perxis-auto-root-eighth-color-inner: var(--perxis-auto-root-eighth-color, #800D63);
  --perxis-auto-root-ninth-color-inner: var(--perxis-auto-root-ninth-color, #E6E4E4);
  --perxis-auto-root-tenth-color-inner: var(--perxis-auto-root-tenth-color, #8A8D8F);
  --perxis-auto-root-eleven-color-inner: var(--perxis-auto-root-eleven-color, #541E66);
  --perxis-auto-root-twelve-color-inner: var(--perxis-auto-root-twelve-color, #2E6399);
  --perxis-auto-root-thirteenth-color-inner: var(--perxis-auto-root-thirteenth-color, #F2F0F080);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
